import React from 'react';
import { useSelector,shallowEqual } from 'react-redux';
import PropTypes from 'prop-types';
import { DynamicField } from '@totalsoft/rocket-ui';
import { getDateFormat, getDynamicFieldControlType } from 'utils/functions';
import { onDynamicInputChange, addPropertyPrefix } from 'utils/propertyChangeAdapters';

const OfferAssetPropertyItemComponent = ({
  prop,
  idx,
  validationInfo,
  onPropertyChange,
  defaultDecimalPlaces,
  readOnly,
  loadPropertyDetailsInternal
}) => {

  const options = useSelector(
    state =>
      state.assetData?.propertyDetails?.[prop.propertyId]?.loaded
    ? state.entities.propertyDetails?.[prop.propertyId] ?? []
    : [],
    shallowEqual
  );

  return (
    <DynamicField
      id={'offerAssetCard_propertiesCard_' + prop?.name?.replace(/\s/g, '-')?.toLowerCase()}
      error={Boolean(validationInfo && validationInfo[idx]?.value) || (prop.mandatory && !prop.value)}
      helperText={validationInfo && validationInfo[idx]?.value}
      controlType={getDynamicFieldControlType(prop.typeCode)}
      inputId={prop.propertyId}
      label={prop.name}
      onChange={onDynamicInputChange(addPropertyPrefix(idx, onPropertyChange)('value'))}
      value={prop.value}
      valueKey={'value'}
      labelKey={'value'}
      inputProps={{ decimalScale: prop.decimalPlaces ?? defaultDecimalPlaces }}
      required={prop.mandatory}
      disabled={readOnly}
      open={readOnly === true ? false : undefined}
      options={options}
      onOpen={loadPropertyDetailsInternal(prop.propertyId)}
      format={getDateFormat()}
    />
  );
};

OfferAssetPropertyItemComponent.propTypes = {
  prop: PropTypes.object.isRequired,
  onPropertyChange: PropTypes.func,
  defaultDecimalPlaces: PropTypes.number,
  readOnly: PropTypes.bool,
  validationInfo: PropTypes.object,
  idx: PropTypes.number,
  loadPropertyDetailsInternal: PropTypes.func
};
export default OfferAssetPropertyItemComponent;
